<template>
  <div style="width:100%">
    <div class="famen_list">
      <div class="famen_item" v-for="(item, index) in valist" :key="item.id">
        <div class="fm_row fm_row1">
          <div class="fm_name">{{ item.name }}</div>
          <div class="fm_xh">
            <!-- <img
              src="../../../assets/images/set.png"
              @click="handleSetting(item)"
            /> -->
          </div>
        </div>
        <div class="fm_row fm_row2">
          <div class="port">端口：{{ item.portNo }}</div>
          <div class="task" v-show="item.tasknum > 0">
            <font color="#f00">{{ item.tasknum }}</font>
            {{ $t("first.task_num") }}
          </div>
          <div class="task" v-show="item.tasknum == 0">
            {{ $t("first.notask") }}
          </div>
        </div>
        <div class="fm_row fm_row3">
          <div class="timer">{{ item.timeStr }}</div>
          <div>
            <van-switch
              class="switch"
              v-model="item.sw"
              @change="handleSwitch($event, item, index)"
              active-value="1"
              inactive-value="0"
              active-color="#1989fa"
              inactive-color="#ccc"
              size="24"
            />
          </div>
        </div>
      </div>
    </div>
    <pageToast ref="pageToast" />
  </div>
</template>

<script>
export default {
  props: {
    setting: {
      type: Function,
      default: argument => {}
    },
    hasDeviceChange: {
      type: Boolean,
      default: false
    },
    refreshing: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      valist: [],
      no: localStorage.getItem("no"),
      isLoading: false
    };
  },

  watch: {
    hasDeviceChange(v) {
      if (v) {
        const no = localStorage.getItem("no");
        this.no = no;
        this.getValaveList(no);
      }
    },

    refreshing(bl) {
      if (bl) {
        this.onRefresh();
      }
    }
  },

  created() {
    console.error("网关阀门");

    const no = localStorage.getItem("no");
    this.no = no;
    this.getValaveList(no);
  },

  methods: {
    // 查询阀门
    async getValaveList(no) {
      if (this.$isblank(no)) {
        this.$toast(this.$t("export.tis_dev"));
        return false;
      }

      await this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0
      });

      await this.$api
        .getValaveList({
          gatewayNo: no
        })
        .then(async res => {
          await this.$toast.clear();
          if (res.errcode === 0) {
            if (!this.$isblank(res.list)) {
              const list = res.list;
              const nowDate = new Date().getTime();
              list.map((item, i) => {
                let timeStep = "";
                item.sw = item.switchStt.toString();
                item.tasklist = "";
                item.tasknum = 0;
                item.timeStr = "00:00:00";
                if (item.lastUpdate && item.switchStt === 1) {
                  // 将 - 替换成 / 兼容 iphone
                  timeStep =
                    nowDate -
                    new Date(`${item.lastUpdate}`.replace(/-/g, "/")).getTime();

                  timeStep = Math.ceil(timeStep / 1000);
                  // 计算出 时 分 秒
                  item.timeStr = this.$calculationTime(timeStep);

                  item.timer = setInterval(() => {
                    timeStep++;
                    item.timeStr = this.$calculationTime(timeStep);
                  }, 1000);
                }

                // 获取任务列表
                this.getValvaTaskList(item.id, i);

                this.$refs.pageToast.type = 0;
              });

              this.valist = list;
            } else {
              this.$refs.pageToast.type = 1;
            }
          } else {
            this.$toast(res.errmsg);
            return false;
          }
        });
    },

    // 读取任务列表
    getValvaTaskList(id, i) {
      this.$api
        .getValvaTaskList({
          valveId: id
        })
        .then(res => {
          if (res.errcode === 0 && res.data && res.data.length) {
            const list = [res.data];
            this.valist[i].tasklist = list;
            this.valist[i].tasknum = list.length;
          } else {
            // this.$toast(res.errmsg);
            this.valist[i].tasknum = 0;
            return false;
          }
        });
    },

    // 设置
    handleSetting(item) {
      sessionStorage.setItem("liveSettingData", JSON.stringify(item));
      this.$router.push({
        path: "/liveSetting",
        query: { type: "fm" }
      });
    },

    // 阀门开闭
    async handleSwitch(value, item, index) {
      try {
        let id = item.id;
        //  1 开 0 关
        this.$toast.loading({
          message: this.$t("valva.val_loading"),
          forbidClick: true,
          duration: 0
        });

        if (this.$isblank(id)) {
          this.$toast(this.$t("valva.val_chose"));
          return false;
        }

        if (Number(value) === 1) {
          item.sw = "0";
          // 先不变开关状态  等接口反馈后在改变
          // 打开
          var ch = true;
          var cn = this.$t("valva.val_open");
        } else {
          // 关闭
          item.sw = "1";
          var ch = false;
          var cn = this.$t("valva.val_close");
        }

        const _this = this;

        await this.$api
          .setValaveDetail({
            gatewayNo: this.no,
            id,
            switchStt: ch
          })
          .then(res => {
            _this.$toast.clear();
            if (res.errcode === 0) {
              // 成功
              _this.$toast.success(
                _this.$t("trend.trend_valve") +
                  cn +
                  _this.$t("valva.val_success")
              );
              // true 是关闭阀门的时候
              if (ch) {
                item.sw = "1";
                let t = 0;
                // 清空定时器
                clearInterval(_this.valist[index].timer);
                // 重新开启定时器
                _this.valist[index].timer = setInterval(() => {
                  t++;
                  _this.valist[index].timeStr = _this.$calculationTime(t);
                }, 1000);
              } else {
                item.sw = "0";
                // 成功后 需要停止掉计时器
                _this.valist[index].timeStr = "00:00:00";
                clearInterval(_this.valist[index].timer);
              }
            } else {
              _this.$toast(res.errmsg);
              return false;
            }
          })
          .catch(err => {
            console.error(err);
          });
      } catch (err) {
        console.error("err:", err);
      }
    },

    async onRefresh() {
      this.isLoading = true;
      await this.getValaveList(this.no);
      this.isLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.fm_name {
  font-size: 14px;
}

.port,
.task {
  font-size: 12px;
}

.famen_list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  // padding: 0 0.3rem;
  justify-content: space-between;

  .famen_item {
    width: 49%;
    height: 2.1rem;
    box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.05);
    border-radius: 0.1rem;
    background: #ffffff;
    margin-bottom: 0.2rem;
    padding: 0.1rem 0.2rem;
    box-sizing: border-box;

    &:nth-child(2n) {
      margin-right: 0 !important;
    }

    .fm_row {
      display: flex;
      height: 34px;
      line-height: 34px;
    }
    .fm_row1 {
      display: flex;
      justify-content: space-between;

      .fm_xh {
        .icon-wifi,
        .icon-dc {
          margin-right: 8px;
        }

        .icon-wifi {
          color: green;
        }

        .icon-dc {
          color: red;
          font-size: 20px;
          vertical-align: bottom;
        }

        img {
          width: 14px;
          height: 14px;
          vertical-align: baseline;
        }
      }
    }

    .fm_row2 {
      display: flex;
      justify-content: space-between;
    }

    .fm_row3 {
      display: flex;
      justify-content: space-between;
      width: 100%;

      .switch {
        font-size: 20px !important;
        vertical-align: middle;
      }
    }
  }
}
</style>
